export const PROMOTION = {
  name: '',
  priority: 0,
  id: 'new',
}

export default PROMOTION
